import RouterPage from './Pages/RouterPage';
import * as React from 'react'

function App() {
  return (
      <div className="App">
        <RouterPage />
      </div>
    );
}
   //this is ifhvbdbhkvb
export default App;
